<script setup lang='ts'>
  import { KsSkeleton, KsSkeletonWrapper  } from '@aschehoug/kloss'
  import { useCssVar } from '@vueuse/core'

  import { randomIntValue } from '@/utils'

  const whiteColor = useCssVar('--color-white')
  const skeletonLoadingColor = useCssVar('--color-blue-30')
  
  const renderSkeletons = (count: number, height: string, width: string, background: string, borderRadius = '0') => {
    return Array.from({ length: count }).map((_, index) => ({
      key: index,
      height,
      width,
      background,
      borderRadius
    }))
  }
</script>

<template>
  <KsSkeletonWrapper class="skeleton-wrapper">
    <KsSkeleton
      height="3rem"
      :width="randomIntValue(20, 40) + '%'"
      :background="skeletonLoadingColor"
    />
    <div class="row">
      <div class="left">
        <template
          v-for="skeleton in renderSkeletons(3, '84px', '640px', whiteColor)"
          :key="skeleton.key"
        >
          <KsSkeleton
            :height="skeleton.height"
            :width="skeleton.width"
            :background="skeleton.background"
            :border-radius="skeleton.borderRadius"
          />
        </template>
      </div>
      <div class="right">
        <KsSkeleton height="100%" :background="skeletonLoadingColor" />
      </div>
    </div>
  </KsSkeletonWrapper>
</template>

<style lang='scss' scoped>
  .skeleton-wrapper {
    background-color: var(--color-violet-10);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    height: fit-content;
    padding: 48px;
    width: 100%;

    .row {
      display: flex;
      width: 100%;
    }

    .left,
    .right {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding: 24px;
    }

    .left {
      padding-left: 0;
      width: 640px;
    }

    .right {
      padding-right: 0;
    }
  }
</style>